// Build two cumulative EPA series (one per team) for the race chart.
// On every play both team lines get a point; the offense's cumulative EPA
// ticks up/down from `scrimmageEpa` while the defense's line stays flat.
export const buildEpaRaceData = (plays, game) => {
  if (!plays?.length || !game?.homeTeam || !game?.awayTeam) {
    return { home: [], away: [] };
  }

  const homeId = game.homeTeam.id;
  const awayId = game.awayTeam.id;

  const sorted = [...plays].sort(
    (a, b) => (a.gameIndex ?? 0) - (b.gameIndex ?? 0),
  );

  let homeEpa = 0;
  let awayEpa = 0;
  const home = [];
  const away = [];

  sorted.forEach((play) => {
    const epa = play.scrimmageEpa;
    const offenseId = play.offenseTeam?.id;

    if (epa != null && offenseId === homeId) homeEpa += epa;
    if (epa != null && offenseId === awayId) awayEpa += epa;

    const x = play.gameIndex ?? 0;
    home.push({ id: `home-${play.id}`, valueX: x, valueY: homeEpa });
    away.push({ id: `away-${play.id}`, valueX: x, valueY: awayEpa });
  });

  return { home, away };
};
